export const LOCAL_STORAGE_CONSTANTS = {
  ACCESS_TOKEN: 'accessToken',
};

export const API_URL = {
  GDPR_FORM: 'api/gdpr/form',
  PING: 'api/gdpr/ping',
  MEDIC_DATA: 'api/gdpr/user',
};
